import { Component } from '@angular/core';

@Component({
  selector: 'stock-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {

}
